import { useMediaQuery } from "react-responsive";
import mediaQueries from "helpers/mediaQueries";

export default function useIsDesktop() {
  const isDesktopOrLaptop = useMediaQuery(mediaQueries.mediaMaxXs);
  return isDesktopOrLaptop;
}
